import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
} from "@react-pdf/renderer";
import React, { useState, useEffect } from "react";
import download from "../../assets/images/download.png";
const Table = ({ children }) => <View style={styles.table}>{children}</View>;
const TableHeader = ({ children }) => (
  <View style={styles.tableHeader}>{children}</View>
);
const TableRow = ({ children }) => (
  <View style={styles.tableRow}>{children}</View>
);

const Cell = ({ children }) => (
  <View style={styles.cell}>
    <Text>{children}</Text>
  </View>
);
const Heading = ({ children }) => (
  <View style={styles.heading}>
    <Text>{children}</Text>
  </View>
);

const styles = {
  table: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#bfbfbf",
    marginTop: 10,
    marginBottom: 10,
  },
  tableHeader: {
    display: "flex",
    backgroundColor: "silver",
    border: "2px solid black",
    flexDirection: "row",
    width: "100%",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  cell: {
    display: "table-cell",
    padding: "6px 12px",
    borderBottomWidth: 1,
    borderBottomColor: "#bfbfbf",
    borderRightWidth: 1,
    borderRightColor: "#bfbfbf",
    width: "33.33%",
    fontSize: 10,
  },
  heading: {
    backgroundColor: "#A3EBB1",
    display: "table-cell",
    padding: "6px 12px",
    width: "100%",
    marginBottom: 5,
    fontSize: 12,
    textTransform: "uppercase",
    textAlign: "center",
  },
};
export const PDFGenerator = ({ data, name }) => {
  const [pdfData, setPdfData] = useState(null);

  useEffect(() => {
    setPdfData(null);
  }, [data]);

  const generatePDF = () => {
    // Use React-PDF to generate a PDF document with a table of data
    const pdf = (
      <Document>
        <Page>
          {data.map((i, index) => (
            <>
              {i.data.length !== 0 ? (
                <Table>
                  <TableRow key={index + 1}>
                    <Heading>{i.key}</Heading>
                  </TableRow>
                  <TableHeader>
                    <Cell>User</Cell>
                    <Cell>Email id</Cell>
                    <Cell>City</Cell>
                    <Cell>State</Cell>
                    <Cell>Contact Number</Cell>
                  </TableHeader>
                  {i.data.map((row) => (
                    <TableRow key={row.id}>
                      {row.name !== null ? (
                        <>
                          {" "}
                          <Cell>{row.name}</Cell>
                          <Cell>{row.email}</Cell>
                          <Cell>{row.city}</Cell>
                          <Cell>{row.state}</Cell>
                          <Cell>{row.mobile}</Cell>
                        </>
                      ) : (
                        ""
                      )}
                    </TableRow>
                  ))}
                </Table>
              ) : (
                ""
              )}
            </>
          ))}
        </Page>
      </Document>
    );

    setPdfData(pdf);
  };

  return (
    <div className="chart-action-group">
      <button
        className="chart-action-button chart-action-button--primary"
        title="Download as PDF"
        onClick={generatePDF}
      >
        Generate PDF
      </button>
      {pdfData && (
        <PDFDownloadLink document={pdfData} fileName={name + ".pdf"}>
          <div className="chart-action-button chart-action-button--download">
            <img src={download} alt="Download PDF" />
            Download
          </div>
        </PDFDownloadLink>
      )}
    </div>
  );
};
